import { Card } from 'primereact/card';
import React from 'react';

export default function EventPackageLinkedItem({ title, items = [] }) {
    return (
        <>           
            {items.map((it, idx) => (
                <Card style={{
                    backgroundColor: 'white',
                    padding: '0.5rem',
                    marginBottom: '0.5rem',
                    border: 'none',
                    boxShadow: '0 0 5px 0 rgba(0, 0, 0, 0.1)'
                  }} key={idx}>
                    <div className="flex justify-content-between align-items-center p-3">
                        <span 
                            className={`keduall-typography heading-h6-normal-400 ${it.labelStyleClass ?? ''}`}
                            onClick={it.onLabelClick}
                        >
                            {it.label}
                        </span>
                        <span
                            className={
                                'keduall-typography heading-h6-semibold-600 ' +
                                (it.colorClass ?? '')
                            }
                        >
                            {it.value}
                        </span>
                    </div>
                </Card>
            ))}
        </>
    );
}
